// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const treeStump = defineModel({
  id: "tree-stump",
  batchId: "future",
  name: "Tree stump",
  tags: ["scenery","tree","stump","low-poly","age-of-mcp","future"],
  summary: "A cut tree stump — what a felled tree leaves; can be cleared or coppiced.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.2,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.14, 0.16, 0.18, 9), color: "#6f4a26", position: [0, 0.09, 0] },
      { geometry: new THREE.CylinderGeometry(0.135, 0.135, 0.02, 9), color: "#c2a070", position: [0, 0.19, 0] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.021, 8), color: "#553820", position: [0, 0.191, 0] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#553820", position: [0.15, 0.03, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.6] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#553820", position: [0.046353, 0.03, 0.142658], rotation: [1.570796, 0, 1.256637], scale: [1, 1, 0.6] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#553820", position: [-0.121353, 0.03, 0.088168], rotation: [1.570796, 0, 2.513274], scale: [1, 1, 0.6] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#553820", position: [-0.121353, 0.03, -0.088168], rotation: [1.570796, 0, 3.769911], scale: [1, 1, 0.6] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#553820", position: [0.046353, 0.03, -0.142658], rotation: [1.570796, 0, 5.026548], scale: [1, 1, 0.6] },
    ] },
    { id: "variant-1", label: "Variant 2", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.14, 0.16, 0.18, 9), color: "#6f4a26", position: [0, 0.09, 0] },
      { geometry: new THREE.CylinderGeometry(0.135, 0.135, 0.02, 9), color: "#c2a070", position: [0, 0.19, 0] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.021, 8), color: "#553820", position: [0, 0.191, 0] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#553820", position: [0.15, 0.03, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.6] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#553820", position: [0.046353, 0.03, 0.142658], rotation: [1.570796, 0, 1.256637], scale: [1, 1, 0.6] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#553820", position: [-0.121353, 0.03, 0.088168], rotation: [1.570796, 0, 2.513274], scale: [1, 1, 0.6] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#553820", position: [-0.121353, 0.03, -0.088168], rotation: [1.570796, 0, 3.769911], scale: [1, 1, 0.6] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#553820", position: [0.046353, 0.03, -0.142658], rotation: [1.570796, 0, 5.026548], scale: [1, 1, 0.6] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.012, 0.14, 5), color: "#6f4a26", position: [0.04, 0.27, 0.03] },
      { geometry: new THREE.ConeGeometry(0.05, 0.14, 6), color: "#5fa04a", position: [0.04, 0.38, 0.03] },
    ] },
  ],
  animations: [],
});
